import React, { useEffect, useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import axios from "axios";
import config from "../../Config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "../../UiComponents/common/Button";
import { applyStudentPortalSessionFromResponse } from "../../utils/studentPortalSession";

function ParentSelectChildren() {
  const navigate = useNavigate();
  const [children, setChildren] = useState([]);
  const [proof, setProof] = useState("");
  const [loadingId, setLoadingId] = useState(null);

  useEffect(() => {
    document.title = "Select student — Parent portal";
    const p = localStorage.getItem("ParentPortalProof") || "";
    if (!p) {
      navigate("/login", { replace: true });
      return;
    }
    setProof(p);
    try {
      const list = JSON.parse(localStorage.getItem("ParentPortalChildren") || "[]");
      setChildren(Array.isArray(list) ? list : []);
    } catch {
      setChildren([]);
    }
  }, [navigate]);

  const openPortalForChild = (studentId) => {
    const parentProof = localStorage.getItem("ParentPortalProof");
    if (!parentProof) {
      toast.error("Session expired. Sign in again.");
      navigate("/login");
      return;
    }
    setLoadingId(studentId);
    axios({
      method: "post",
      url: config.base_url + "Student/ParentSelectStudent",
      headers: { "Content-Type": "application/json" },
      data: { ParentProof: parentProof, Student_ID: studentId },
    })
      .then((res) => {
        if (applyStudentPortalSessionFromResponse(res.data)) {
          localStorage.setItem("ParentPortalMode", "1");
          toast.success("Opening student portal…");
          navigate("/student-panel/dashboard");
        } else {
          toast.error(
            res.data?.status_message || "Could not open portal for this student."
          );
        }
      })
      .catch(() => toast.error("Network error."))
      .finally(() => setLoadingId(null));
  };

  if (!proof) return null;

  return (
    <>
      <ToastContainer />
      <div className="content-center">
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <h2 className="mb-2">Your children</h2>
              <p className="text-muted small mb-4">
                Select a child to use the same student portal (fees, results, attendance, etc.).
                You can switch children later from the top bar.
              </p>
              {children.length === 0 ? (
                <p className="text-muted">No students linked to this login.</p>
              ) : (
                <ul className="list-group">
                  {children.map((c) => (
                    <li
                      key={c.Student_ID}
                      className="list-group-item d-flex flex-wrap justify-content-between align-items-center gap-2"
                    >
                      <div>
                        <strong>{c.Student_Name}</strong>
                        <div className="small text-muted">
                          {c.Registration_No}
                          {c.Class_Name ? ` · ${c.Class_Name}` : ""}
                          {c.Section_Name ? ` ${c.Section_Name}` : ""}
                          {c.Wing_Name ? ` · ${c.Wing_Name}` : ""}
                        </div>
                      </div>
                      <Button
                        type="button"
                        className="button-primary"
                        children={loadingId === c.Student_ID ? "Please wait…" : "Open portal"}
                        loading={loadingId === c.Student_ID}
                        disabled={loadingId != null}
                        onClick={() => openPortalForChild(c.Student_ID)}
                      />
                    </li>
                  ))}
                </ul>
              )}
              <div className="mt-4 text-center">
                <NavLink to="/login">Back to sign in</NavLink>
                {" · "}
                <NavLink to="/login">Staff sign in</NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ParentSelectChildren;
